// Turbo Drive is disabled app-wide (see entrypoints/application.js), which also
// disables Turbo's handling of `data-turbo-method` links — without it they fall
// back to a plain GET and 404/500 (e.g. logout, archive, delete buttons).
//
// This shim restores that behaviour without re-enabling Drive: a click on any
// link carrying data-turbo-method submits a real form with the correct HTTP
// method, the CSRF token, and an optional confirm prompt (data-turbo-confirm,
// falling back to data-confirm).

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.content : null
}

function hiddenInput(name, value) {
  const input = document.createElement('input')
  input.type = 'hidden'
  input.name = name
  input.value = value
  return input
}

document.addEventListener('click', function (event) {
  const link = event.target.closest('a[data-turbo-method]')
  if (!link) return

  const method = (link.getAttribute('data-turbo-method') || '').toLowerCase()
  const url = link.getAttribute('href')
  if (!method || !url || url === '#') return

  event.preventDefault()

  const message = link.getAttribute('data-turbo-confirm') || link.getAttribute('data-confirm')
  if (message && !window.confirm(message)) return

  if (method === 'get') {
    window.location.href = url
    return
  }

  const form = document.createElement('form')
  form.method = 'post'
  form.action = url
  form.style.display = 'none'
  form.appendChild(hiddenInput('_method', method))

  const token = csrfToken()
  if (token) form.appendChild(hiddenInput('authenticity_token', token))

  document.body.appendChild(form)
  form.submit()
})

// button_to renders a real <form> (so the correct HTTP method fires even with Drive off),
// but its confirmation prompt is carried as data-turbo-confirm on the form/button — and with
// Turbo Drive off, Turbo no longer intercepts form submits, so that confirm never showed.
// The result: destructive button_to deletes (admin/forms, form-folders, Settings > Users, …)
// ran on a single misclick with NO confirmation. Restore the prompt on submit, reading the
// message from the submitter button first, then the form (also honoring plain data-confirm).
document.addEventListener('submit', function (event) {
  const form = event.target
  if (!(form instanceof HTMLFormElement)) return

  const submitter = event.submitter
  const message =
    (submitter && (submitter.getAttribute('data-turbo-confirm') || submitter.getAttribute('data-confirm'))) ||
    form.getAttribute('data-turbo-confirm') ||
    form.getAttribute('data-confirm')

  if (message && !window.confirm(message)) {
    event.preventDefault()
    event.stopPropagation()
  }
})
